
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_k2y2q_12ve8_44",
  "checkbox-control": "awsui_checkbox-control_k2y2q_12ve8_77",
  "outline": "awsui_outline_k2y2q_12ve8_93"
};
  